import type { ReactNode } from "react";
import PossibilityIndicator from "@/components/possibility-indicator.tsx";
import Image from "@/components/ui/image.tsx";
import ChoiceTooltip from "@/features/sub-families/components/choice-tooltip.tsx";
import type { ImageType, Nullable, Nullish } from "@/types";
import { isText } from "@/utils/types.ts";
import Button from "./button.tsx";

type Props = {
    image: Nullable<ImageType>;
    label: ReactNode;
    isChecked: boolean;
    tooltip?: Nullable<string>;
    description?: Nullish<string>;
    isDisabled?: boolean;
    isPossible?: boolean;
    onClick: () => void;
};

export default function CheckboxWithImage({
    image,
    label,
    description,
    isChecked,
    isDisabled,
    isPossible = true,
    onClick,
    tooltip,
}: Props) {
    return (
        <div className="checkbox-with-image">
            <Button className="checkbox-with-image__button" onClick={onClick} disabled={isDisabled}>
                <div className="checkbox-with-image__img">{!!image && <Image image={image} />}</div>
                <span className="checkbox-with-image__check custom-control">
                    <input
                        className="custom-control__input"
                        type="checkbox"
                        checked={isChecked}
                        disabled={isDisabled}
                        readOnly
                    />
                </span>
            </Button>
            <div className="checkbox-with-image__content">
                <span className="checkbox-with-image__label">
                    {label}
                    {!isPossible && <PossibilityIndicator />}
                </span>
                <ChoiceTooltip label={label} tooltip={tooltip ?? null} image={image} />
                {isText(description) && <span className="checkbox-with-image__description">{description}</span>}
            </div>
        </div>
    );
}
